/**
 * Generatore Codice Fiscale Italiano
 * Calcola automaticamente il CF basandosi su nome, cognome, data e luogo di nascita
 */

// Tabella codici catastali comuni italiani (campione - da espandere)
const COMUNI = {
  'roma': 'H501',
  'milano': 'F205',
  'napoli': 'F839',
  'torino': 'L219',
  'palermo': 'G273',
  'genova': 'D969',
  'bologna': 'A944',
  'firenze': 'D612',
  'bari': 'A662',
  'catania': 'C351',
  'venezia': 'L736',
  'verona': 'L781',
  'messina': 'F158',
  'padova': 'G224',
  'trieste': 'L424',
  'taranto': 'L049',
  'brescia': 'B157',
  'parma': 'G337',
  'prato': 'G999',
  'modena': 'F257',
  'reggio calabria': 'H224',
  'reggio emilia': 'H223',
  'perugia': 'G478',
  'ravenna': 'H199',
  'livorno': 'E625',
  'cagliari': 'B354',
  'foggia': 'D643',
  'rimini': 'H294',
  'salerno': 'H703',
  'ferrara': 'D548',
  'sassari': 'I452',
  'latina': 'E472',
  'giugliano in campania': 'E054',
  'monza': 'F704',
  'siracusa': 'I754',
  'pescara': 'G482',
  'bergamo': 'A794',
  'forlì': 'D704',
  'trento': 'L378',
  'vicenza': 'L840',
  'terni': 'L117',
  'bolzano': 'A952',
  'novara': 'F952',
  'piacenza': 'G535',
  'ancona': 'A271',
  'andria': 'A285',
  'arezzo': 'A390',
  'udine': 'L483',
  'cesena': 'C573',
  'lecce': 'E506',
  'pesaro': 'G479',
  'alessandria': 'A182',
  'la spezia': 'E463',
  'catanzaro': 'C352',
  'pistoia': 'G713',
  'brindisi': 'B180',
  'como': 'C933',
  'cosenza': 'D086',
  'grosseto': 'E202',
  'l\'aquila': 'A345',
  'lucca': 'E715',
  'potenza': 'G942',
  'campobasso': 'B519',
  'varese': 'L682',
  'asti': 'A479',
  'matera': 'F052',
  'avellino': 'A509',
  'benevento': 'A783',
  'caserta': 'B963',
};

// Consonanti e vocali
const isVowel = (char) => 'AEIOU'.includes(char.toUpperCase());
const isConsonant = (char) => /[A-Z]/i.test(char) && !isVowel(char);

// Estrai consonanti e vocali
const getConsonants = (str) => str.toUpperCase().split('').filter(isConsonant);
const getVowels = (str) => str.toUpperCase().split('').filter(isVowel);

// Calcola codice cognome (3 caratteri)
const calcCognome = (cognome) => {
  const clean = cognome.replace(/[^a-zA-Z]/g, '');
  const cons = getConsonants(clean);
  const vow = getVowels(clean);
  const chars = [...cons, ...vow, 'X', 'X', 'X'];
  return chars.slice(0, 3).join('');
};

// Calcola codice nome (3 caratteri)
const calcNome = (nome) => {
  const clean = nome.replace(/[^a-zA-Z]/g, '');
  const cons = getConsonants(clean);
  const vow = getVowels(clean);
  
  // Se ci sono 4+ consonanti, prendi 1a, 3a, 4a
  if (cons.length >= 4) {
    return [cons[0], cons[2], cons[3]].join('');
  }
  
  const chars = [...cons, ...vow, 'X', 'X', 'X'];
  return chars.slice(0, 3).join('');
};

// Mappa mesi
const MESI = ['A', 'B', 'C', 'D', 'E', 'H', 'L', 'M', 'P', 'R', 'S', 'T'];

// Calcola codice data e sesso
const calcDataSesso = (dataNascita, sesso) => {
  const date = new Date(dataNascita);
  const anno = String(date.getFullYear()).slice(-2);
  const mese = MESI[date.getMonth()];
  let giorno = date.getDate();
  
  // Per le donne aggiungi 40 al giorno
  if (sesso && sesso.toUpperCase() === 'F') {
    giorno += 40;
  }
  
  return `${anno}${mese}${String(giorno).padStart(2, '0')}`;
};

// Trova codice catastale del comune
const getCodiceComune = (comune) => {
  if (!comune) return 'XXXX';
  const normalizedComune = comune.toLowerCase().trim();
  return COMUNI[normalizedComune] || 'XXXX';
};

// Tabella caratteri di controllo
const DISPARI = {
  '0': 1, '1': 0, '2': 5, '3': 7, '4': 9, '5': 13, '6': 15, '7': 17, '8': 19, '9': 21,
  'A': 1, 'B': 0, 'C': 5, 'D': 7, 'E': 9, 'F': 13, 'G': 15, 'H': 17, 'I': 19, 'J': 21,
  'K': 2, 'L': 4, 'M': 18, 'N': 20, 'O': 11, 'P': 3, 'Q': 6, 'R': 8, 'S': 12, 'T': 14,
  'U': 16, 'V': 10, 'W': 22, 'X': 25, 'Y': 24, 'Z': 23
};

const PARI = {
  '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9,
  'A': 0, 'B': 1, 'C': 2, 'D': 3, 'E': 4, 'F': 5, 'G': 6, 'H': 7, 'I': 8, 'J': 9,
  'K': 10, 'L': 11, 'M': 12, 'N': 13, 'O': 14, 'P': 15, 'Q': 16, 'R': 17, 'S': 18, 'T': 19,
  'U': 20, 'V': 21, 'W': 22, 'X': 23, 'Y': 24, 'Z': 25
};

const CONTROLLO = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

// Calcola carattere di controllo
const calcControllo = (cf15) => {
  let sum = 0;
  for (let i = 0; i < 15; i++) {
    const char = cf15[i];
    sum += (i % 2 === 0) ? DISPARI[char] : PARI[char];
  }
  return CONTROLLO[sum % 26];
};

/**
 * Genera il codice fiscale
 * @param {string} nome - Nome
 * @param {string} cognome - Cognome
 * @param {string} dataNascita - Data di nascita (YYYY-MM-DD)
 * @param {string} sesso - 'M' o 'F'
 * @param {string} luogoNascita - Comune di nascita
 * @returns {string} Codice fiscale o stringa vuota se dati insufficienti
 */
export const generateFiscalCode = (nome, cognome, dataNascita, sesso, luogoNascita) => {
  if (!nome || !cognome || !dataNascita || !sesso) {
    return '';
  }
  
  try {
    const codCognome = calcCognome(cognome);
    const codNome = calcNome(nome);
    const codData = calcDataSesso(dataNascita, sesso);
    const codComune = getCodiceComune(luogoNascita);
    
    const cf15 = `${codCognome}${codNome}${codData}${codComune}`;
    const controllo = calcControllo(cf15);
    
    return `${cf15}${controllo}`;
  } catch (error) {
    console.error('Errore generazione CF:', error);
    return '';
  }
};

export default generateFiscalCode;
